
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/drinks",
      function () {
        return require("private-next-pages/collections/drinks.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/drinks"])
      });
    }
  